/*
 * rootReducer.js
 * trt_cms2
 *
 * Created by Hisyam on 27/2/2020.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

import {postsReducer} from "./blogs/blogsReducer";
import {AUTH_ERROR, LOGOUT_SUCCESS} from "./types";
import {combineReducers} from "redux";
import authReducer from "./auth/authReducer";
import {careersReducer} from "./careers/careersReducer";
import {imageReducer} from "./images/imagesReducer";
import {pagesReducer} from "./pages/pagesReducer";
import {clientsReducer} from "./clients/clientsReducer";
import {testimonialsReducer} from "./testimonials/testimonialsReducer";
import {worksReducer} from "./works/worksReducer";
import {servicesReducer} from "./services/servicesReducer";
import {maestrosReducer} from "./companies/companiesReducer";
import {employeesReducer} from "./employee/employeeReducer";
import {achievementsReducer} from "./achievements/achievementsReducer";
import {sectionsReducer} from "./sections/sectionsReducer";

const appReducer = combineReducers({
  "auth": authReducer,
  "pages": pagesReducer,
  "posts": postsReducer,
  "careers": careersReducer,
  "images": imageReducer,
  "clients": clientsReducer,
  "testimonials": testimonialsReducer,
  "works": worksReducer,
  "services": servicesReducer,
  "maestros": maestrosReducer,
  "employees": employeesReducer,
  "achievements": achievementsReducer,
  "sections": sectionsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_SUCCESS || action.type === AUTH_ERROR) {
    state = undefined;
  }

  return appReducer(state, action)
};

export default rootReducer;